import { Group } from '@antv/g';
// A empty component to pass parse view tree stage.
export var Legends = function Legends(options) {
  return function () {
    return new Group();
  };
};
Legends.props = {};